<div>
  <div class="header-modal">
    <div>
      <span>Confirmation</span>
    </div>
    <div>
      <mat-icon class="pointer" [mat-dialog-close]="false">close</mat-icon>
    </div>
  </div>
  <div mat-dialog-content>{{ data.message }}</div>
  <div mat-dialog-actions>
    <button mat-stroked-button [mat-dialog-close]="true">
      {{ data.yesBtn ? data.yesBtn : 'Yes' }}
    </button>
    @if (!data.hideNoBtn) {
      <button mat-stroked-button [mat-dialog-close]="false">
        {{ data.noBtn ? data.noBtn : 'No' }}
      </button>
    }
  </div>
</div>
